module.exports = __webpack_public_path__ + "static/media/rajvee_shah.9016ae01.png";